<template>
  <v-row v-if="error.getFilesError" no-gutters align="center" justify="center">
    <v-card width="800" height="1000" class="my-16" flat>
      <v-row no-gutters justify="center" align="center">
        <v-col
          cols="8"
          class="d-flex justify-start align-start mb-3 flex-column"
        >
          <v-row class="flex-column" justify="center" align="center" no-gutters>
            <v-card flat height="25">
              <span class="footerText align-text d-block">
                {{ error.shownErrMsg }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="18" v-bind="attrs" v-on="on">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <v-container
                    class="text-body-2 pa-0"
                    style="max-width: 230px"
                  >
                    {{ error.tooltipErrMsg }}
                  </v-container>
                </v-tooltip>
              </span>
            </v-card>
          </v-row>
          <br />
          <span class="text-subheading">
            {{ $t('message.videoApiErrMsg') }} <br />
            <button
              type="button"
              class="primary--text"
              @click="handleStatusPage"
            >
              <span class="primary--text">
                {{ $t('message.checkStatusPageLink') }}
              </span>
            </button>
          </span>
          <br />
        </v-col>
        <v-col cols="12">
          <v-row no-gutters align="center" justify="center">
            <v-btn
              color="primary"
              class="ma-2 ml-3 white--text"
              rounded
              @click="readAllFiles"
            >
              <span class="mx-2">{{ $t('message.tryAgain') }}</span>
              <v-icon right dark> mdi-cached </v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-row>

  <page-view v-else :is-loading="isFetching" class="page-videos" fill-height>
    <template #header>
      <base-header
        :title="pageTitle"
        :menu="pageMenu"
        :title-beta="isBeta ? true : false"
        :has-intro="!isMobileBreakpoint"
        @back="handleRoot"
      >
        <template #actions>
          <template v-if="hasEditVideoPerm">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: on, attrs: attrs }">
                <div v-bind="attrs" v-on="on">
                  <base-btn
                    @click="handleCreatePlaylist"
                    :data-intro="`<strong>${$t(
                      'message.introJS.videos.createPlaylist'
                    )}</strong><br><br>${$t(
                      'message.introJS.videos.createBodyPlaylistClick'
                    )}`"
                  >
                    <span class="responsive-text">
                      {{ $t('message.createPlaylistBtn') }}
                    </span>
                  </base-btn>
                </div>
              </template>
              <span>{{ $t('message.noPermissionToDo') }}</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-card width="250px"></v-card>
          </template>
        </template>
      </base-header>
    </template>
    <template #content>
      <v-col
        v-if="false"
        :cols="isMobileBreakpoint || isTabletBreakpoint ? 12 : 'auto'"
        :order="isMobileBreakpoint || isTabletBreakpoint ? 'first' : ''"
        class="ml-auto d-flex justify-space-between mr-4"
      >
        <SearchBar
          v-show="!isMobileBreakpoint"
          :list="searchList"
          :fuseOptions="searchFuseOptions"
          :placeholder="
            $t('message.pages.videosDataTable.searchBar.placeholder')
          "
          @filterList="($value) => (filterList = $value)"
        />
        <span class="body-regular-smaller textType6--text">
          {{ pageInfo }}
        </span>
      </v-col>
      <!-- data-table::header -->
      <v-card
        v-show="tableHeaderVisible"
        flat
        width="100%"
        class="data-table__header"
      >
        <v-row no-gutters>
          <v-col class="d-flex align-center justify-start">
            <v-row no-gutters>
              <span class="caption mr-1 ml-3"> Playlist </span>
            </v-row>
          </v-col>
          <v-card
            v-if="columns[1].visible"
            class="d-flex align-center"
            height="45px"
            flat
            width="125px"
          >
            <span class="caption pr-1">
              {{ $t('message.playlist.table.access') }}
            </span>
          </v-card>

          <!-- New Videos Quantity Column -->
          <v-card
            v-if="columns[2].visible"
            class="d-flex align-center"
            height="45px"
            flat
            width="110px"
          >
            <span class="caption pr-1">
              {{ $t('message.playlist.table.videos') }}
            </span>
          </v-card>

          <!-- New Duration Column -->
          <v-card
            v-if="columns[3].visible"
            class="d-flex align-center"
            height="45px"
            flat
            width="110px"
          >
            <span class="caption pr-1">
              {{ $t('message.playlist.table.duration') }}
            </span>
          </v-card>

          <v-card
            v-if="columns[4].visible"
            class="d-flex align-center"
            height="45px"
            flat
            width="195px"
          >
            <span class="caption pr-1">
              {{ $t('message.playlist.table.modification') }}
            </span>
          </v-card>
        </v-row>
      </v-card>
      <!-- data-table::header-full-width -->
      <edit-playlist-modal />
      <remove-modal />
      <portal-target
        id="tooltip-portal"
        name="flagTooltipPortal"
      ></portal-target>

      <!-- data-table -->
      <vue-virtual-table
        v-if="playlists.length > 0"
        ref="dataTableContent"
        class="data-table__content"
        :class="{ virtualTable: $vuetify.theme.dark }"
        :config="tableConfig"
        :data="playlists"
        :height="tableHeight"
        :itemHeight="72"
        :minWidth="300"
        @click="handleAccessPlaylist"
        style="position: relative; z-index: 1"
      >
        <template slot-scope="scope" slot="nameCommon">
          <v-row
            no-gutters
            style="position: relative; max-width: 100%"
            align="center"
            class="data-index pl-4"
            :data-index="scope.index"
            @click="handleAccessPlaylist(scope.row)"
          >
            <v-row
              no-gutters
              align="center"
              style="max-width: 100%; margin-top: 5px"
            >
              <img
                :src="
                  scope.row.image_url ||
                  require('@/assets/playlistPage/placeholder-pandaplaylist.svg')
                "
                width="64"
                height="36"
                class="mr-3 playlist-thumbnail"
                @error="handleImageError($event)"
              />
              <span class="text-truncate" :title="scope.row.name">{{
                scope.row.name
              }}</span>
            </v-row>
          </v-row>
        </template>
        <template slot-scope="scope" slot="accessCommom">
          <v-row
            class="pl-3"
            no-gutters
            justify="start"
            @click="handleAccessPlaylist(scope.row)"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-on="on" v-bind="attrs">
                  <simple-svg
                    v-on="on"
                    v-bind="attrs"
                    :src="
                      scope.row.access_type === 'anyone_with_link'
                        ? require('@/assets/playlist_link.svg')
                        : require('@/assets/playlist_key.svg')
                    "
                    width="18px"
                    height="18px"
                  />
                </span>
              </template>
              <span v-if="scope.row.access_type === 'anyone_with_link'">{{
                $t('message.playlists.tooltipAccessLink')
              }}</span>
              <span v-else>{{ $t('message.playlists.tooltipAccessKey') }}</span>
            </v-tooltip>
          </v-row>
        </template>
        <template slot-scope="scope" slot="videosQuantityCommon">
          <v-row
            no-gutters
            justify="start"
            @click="handleAccessPlaylist(scope.row)"
          >
            <span class="text-center pl-4">
              {{ scope.row.videos_quantity || 0 }}
            </span>
          </v-row>
        </template>

        <template slot-scope="scope" slot="durationCommon">
          <v-row
            no-gutters
            justify="start"
            @click="handleAccessPlaylist(scope.row)"
          >
            <span class="text-center">
              {{ formatDuration(scope.row.duration) }}
            </span>
          </v-row>
        </template>
        <template slot-scope="scope" slot="lastModifiedCommom">
          <v-row
            no-gutters
            justify="start"
            @click="handleAccessPlaylist(scope.row)"
          >
            <div v-if="!!scope.row.type"></div>
            <span class="text-center" v-else>
              {{
                new Date(scope.row.updated_at).toLocaleString('pt-BR', {
                  day: '2-digit',
                }) +
                ' ' +
                new Date(scope.row.updated_at)
                  .toLocaleString(getLocale(), { month: 'short' })
                  .charAt(0)
                  .toUpperCase() +
                new Date(scope.row.updated_at)
                  .toLocaleString(getLocale(), { month: 'short' })
                  .slice(1) +
                ' ' +
                new Date(scope.row.updated_at).toLocaleString('pt-BR', {
                  year: 'numeric',
                })
              }}
            </span>
          </v-row>
        </template>
        <template slot-scope="scope" slot="dotsColumn">
          <v-row no-gutters justify="start" class="pl-2">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on"> mdi-dots-vertical </v-icon>
              </template>
              <v-list style="width: 200px">
                <v-list-item @click="handleAccessPlaylist(scope.row)">
                  <v-list-item-title>
                    {{ $t('message.edit') }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="handleRenamePlaylist(scope.row)">
                  <v-list-item-title>
                    {{ $t('message.rename') }}
                  </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="handleDeletePlaylist(scope.row)">
                  <v-list-item-title>
                    <span class="error--text">Remover</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </template>
      </vue-virtual-table>
      <!-- empty list -->
      <template v-if="playlists.length === 0">
        <v-container class="empty__container" fill-height>
          <v-row
            class="d-flex flex-column"
            no-gutters
            justify="center"
            align="center"
          >
            <img
              class="emptyStateTitle mb-4"
              src="@/assets/playlistEmptyState.svg"
              max-width="240"
            />
            <span class="noFilesAddedText emptyStateTitle textType3--text">
              {{ $t('message.playlist.empty.title') }}
            </span>
            <span class="noFilesAddedText emptyStateDesc textType6--text">
              {{ $t('message.playlist.empty.description') }}
            </span>
            <v-btn
              class="btnStyle elevation-0 my-4"
              :color="$vuetify.theme.dark ? 'btnColor' : 'primary'"
              small
              @click="handleCreatePlaylist"
            >
              <span>
                {{ $t('message.playlist.empty.button') }}
              </span>
            </v-btn>
            <span class="playlist-example">
              <a target="_blank" type="primary" :href="playlistExampleLink">
                <span class="body-bold-small">
                  {{ $t('message.playlist.empty.example') }}
                </span>
                <v-icon class="body-bold-small" size="12"
                  >mdi-open-in-new</v-icon
                >
              </a>
            </span>
          </v-row>
        </v-container>
      </template>
    </template>
  </page-view>
</template>
<script>
// external imports
import VueVirtualTable from 'vue-virtual-table'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'

// internal imports
import calcMegabytesMixin from '@/utils/calcMegabytes'
import externalSourceVideo from '@/utils/externalSourceVideo.mixin.js'
import videosListMixin from '@/utils/videosList.mixin.js'
import { embedOptions as platformsOfEmbed } from '@/utils/embedOptions.js'
import i18n from '@/translations/lang'
import Storage from '@/utils/Storage'
import { PANDA_STATUS_PAGE, PANDA_HELP_CONVERTING } from '@/config/envs'
import embedCode from '@/utils/embedCode.mixin.js'
import embedOptionOrientations from '@/utils/embedOptionOrientations.js'
import introMixin from '@/utils/intro.mixin.js'
import formatTimeMixin from '@/utils/formatTime.mixins.js'
import downloadUrlMixin from '@/utils/downloadUrl.mixin.js'
import langCodesMixin from '@/utils/langCodes.mixin.js'
import batchAiGenerationMixin from '@/utils/batchAiGeneration.mixin.js'

// API
import playlistApi from '@/services/playlistApi'

// Components
import BaseBtn from '@/components/BaseBtn.vue'
import PageView from '@/layout/PageViewV2.vue'
import SearchBar from '@/components/SearchBar.vue'
import EditPlaylistModal from './EditModal.vue'
import RemoveModal from './RemoveModal.vue'

const newGhostImg = document.createElement('img')
newGhostImg.setAttribute(
  'src',
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQIW2OYKJ38HwAEXwIP2K67AAAAAABJRU5ErkJggg=='
)
newGhostImg.style =
  'position:absolute;top:0;left:0;z-index:-1;width:0.1px;height:0.1px;'
newGhostImg.classList.add('hideGhostImage')

export default {
  name: 'Playlists',
  components: {
    VueVirtualTable,
    SearchBar,
    PageView,
    BaseHeader: () => import('@/components/BaseHeaderV2.vue'),
    BaseBtn,
    EditPlaylistModal,
    RemoveModal,
  },
  data: () => ({
    scrollThreshold: null,
    showActionsModal: false,
    tableHeaderVisible: true,
    menuVisible: false,
    menuX: 0,
    menuY: 0,
    columns: [
      {
        name: 'Nome',
        visible: true,
      },
      {
        name: 'Acesso',
        visible: true,
      },
      {
        name: 'Vídeos',
        visible: true,
      },
      {
        name: 'Duração',
        visible: true,
      },
      {
        name: 'Modificação',
        visible: true,
      },
      {
        name: '',
        visible: true,
      },
    ],
    settedOrder: '',
    isVideo: false,
    showFloatMenu: true,
    isLoading: false,
    isRenameModalOpen: false,
    isDotCom: false,
    searchFuseOptions: {
      keys: ['title', 'name', 'id', 'video_external_id', 'description'],
      includeScore: true,
      threshold: 0.4,
    },
    filterList: 'all',
    isExternalSourceVideo: false,
    openDuplicateVideoModal: false,
    videoToBeDuplicated: undefined,
    showMenuEmbed: false,
    mustShowEmbedModal: false,
    videoId: '',
    video: {},
    menuPosition: {
      x: 1920,
      y: 72,
    },
    embedVideo: {
      width: 720,
      height: 360,
      startTimeCheckbox: false,
      startTime: '',
    },
    videoCustomSize: false,
    tooltipVisible: false,
    fetching: true,
    nameOrder: 'asc',
    sizeOrder: 'asc',
    timeOrder: 'asc',
    lastModifiedOrder: 'asc',
    langOrder: 'asc',
    tableHeight: window.innerHeight - 300,
    authToken: '',
    showMenu: false,
    blockFolder: false,
    showPreview: false,
    previewTimeout: false,
    clearPreviewTimeout: false,
    menuItem: {},
    x: 0,
    y: 0,
    xMenu: 0,
    yMenu: 0,
    isHandleImportModal: true,
    isLoadedPlanInfo: false,
    isFetching: false,
    filesLoading: false,
    embedOptionOrientations,
    error: {
      getFilesError: false,
      shownErrMsg: '',
      tooltipErrMsg: '',
    },
    unknownErrorCode: '504',
    resizeWindowTimeout: null,
    db: null,
    csvItems: [],
    csvLoading: false,
    downloadServer: '',
    isBeta: false,
    externalIdEmbed: false,
    dbFailed: false,
    filter: '',
    availableSpaceBelow: 0,
    screenHeight: 0,
    isRelocating: false,
    svgContent: null,
    playlists: [],
  }),
  mixins: [
    calcMegabytesMixin,
    embedCode,
    introMixin,
    externalSourceVideo,
    videosListMixin,
    formatTimeMixin,
    downloadUrlMixin,
    langCodesMixin,
    batchAiGenerationMixin,
  ],
  computed: {
    ...mapGetters('user', ['canSeePlanInfo']),
    ...mapState('user', {
      planInfo: 'userPlanInfo',
      isTabletBreakpoint: 'isTabletBreakpoint',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    tableConfig() {
      const tableConfig = [
        {
          prop: '_action',
          name: i18n.t('message.name'),
          actionName: 'nameCommon',
          alignItems: 'start',
        },
        {
          prop: '_action',
          name: 'Acesso',
          actionName: 'accessCommom',
          width: 120,
          isHidden: !this.columns[1].visible,
        },
        {
          prop: '_action',
          name: 'Vídeos',
          actionName: 'videosQuantityCommon',
          width: 110,
          isHidden: !this.columns[2].visible,
        },
        {
          prop: '_action',
          name: 'Duração',
          actionName: 'durationCommon',
          width: 110,
          isHidden: !this.columns[3].visible,
        },
        {
          prop: '_action',
          actionName: 'lastModifiedCommom',
          name: 'Modificação',
          isHidden: !this.columns[2].visible,
          width: 150,
        },
        {
          prop: '_action',
          actionName: 'dotsColumn',
          name: '',
          width: 50,
        },
      ]

      return tableConfig
    },
    searchList() {
      let folders = [...this.mainFolders]
      // eslint-disable-next-line no-unused-vars
      let vids = this.allItems
      const _this = this
      if (this.filterList === 'all' || this.filterList === 'videos') {
        //eslint-disable-next-line vue/no-async-in-computed-properties
        return new Promise((resolve) => {
          window.db.videos.toArray().then((list) => {
            if (_this.filterList === 'all') {
              for (const folder of [...folders]) {
                list.push(folder)
              }
            }
            return resolve(list)
          })
        })
      } else if (this.filterList === 'folders') {
        return [...folders]
      }
      return []
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    permissions() {
      if (this.planInfo?.subscription_metadata?.blocked_permissions) {
        try {
          const data = JSON.parse(
            this.planInfo?.subscription_metadata?.blocked_permissions
          )
          if (Array.isArray(data)) return data
        } catch (err) {
          console.error(err)
        }
      }
      return []
    },
    getDefaultColor() {
      return this.$vuetify.theme.dark ? 'main' : 'white'
    },
    inRoute() {
      return this.$route
    },
    aspectRatio() {
      const { width, height } = this.menuItem
      let ratio = height / width
      if (Number.isNaN(ratio)) {
        ratio = 9 / 16
      }
      return `${ratio * 100}%`
    },
    isLandscapeOrientation() {
      return parseFloat(this.aspectRatio) < 100
    },
    embedOptions() {
      const [general] = platformsOfEmbed.filter(
        ({ value }) => value === 'general'
      )
      const rest = platformsOfEmbed.filter(({ value }) => value !== 'general')
      const sorted = rest.sort((a, b) => a.value.localeCompare(b.value))
      return [general, ...sorted]
    },
    pageTitle() {
      return 'Playlists'
    },
    pageMenu() {
      const i18n = this.$i18next
      const path = 'message.pages.video.pageMenu'
      const currentPath = this.$route.path

      return [
        {
          title: i18n.t(`${path}.videos`),
          to: currentPath.startsWith('/folders') ? currentPath : '/videos',
          exact: false,
        },
        {
          title: 'Playlists',
          to: '/video/playlists',
          exact: true,
          dataIntro: `<strong>${i18n.t(
            'message.introJS.videos.createPlaylist'
          )}</strong><br><br>${i18n.t(
            'message.introJS.videos.createBodyPlaylist'
          )}`,
        },
        {
          title: i18n.t(`${path}.trash`),
          to: '/video/trash',
          exact: true,
        },
      ]
    },
    pageInfo() {
      return 'Playlists'
    },
    isPtBr() {
      if (this.$i18next.language === 'pt' || this.$i18next.language === 'pt-BR')
        return true
      return false
    },
    isEs() {
      if (this.$i18next.language === 'es') return true
      return false
    },
    isEn() {
      if (this.$i18next.language === 'en') return true
      return false
    },
    isPandaUs() {
      const hostname = window.location.hostname

      if (hostname === 'localhost') {
        return false
      }

      return hostname.endsWith('.com') && !hostname.endsWith('.com.br')
    },
    svgDataUrl() {
      return `data:image/svg+xml;utf8,${encodeURIComponent(this.svgContent)}`
    },
    playlistExampleLink() {
      const link =
        'https://playlist.tv.pandavideo.com/playlist/e25a5bb7-6522-4eb3-bd97-8e8d1526069d'
      return link
    },
  },
  async created() {
    await this.pageRequests()
    this.setTableHeight()
  },
  mounted() {
    this.$root.$on('changeLanguage', () => {
      this.updateColumnNames()
    })
    this.$root.$on('addPlaylistVideosPage', (playlist) => {
      this.playlists.push(playlist)
    })
    this.$root.$on('removePlaylistListing', (playlist) => {
      this.playlists = this.playlists.filter((p) => p.id !== playlist.id)
    })
    this.$root.$on('updatePlaylistPage', (playlist) => {
      this.playlists = this.playlists.map((p) =>
        p.id === playlist.id ? playlist : p
      )
    })
    this.handleWidth()
    window.addEventListener('resize', this.handleWidth)

    this.authToken = Storage.getItem('accessToken')
    this.isBeta = location.search.match('beta')
    this.isDotCom = !location.host.includes('.com.br')

    window.addEventListener('resize', this.resizeTimeout)
    this.intro_key = 'playlist'
    if (!this.playlists.length)
      this.setIntroJS({ key: 'playlist', delay: 7500 })
    this.$nextTick(() => {
      this.setTableHeight()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWidth)
    window.removeEventListener('resize', this.resizeTimeout)
  },
  watch: {
    lastModifiedOrder: function () {
      this.settedOrder = 'orderByLastModified'
      this.orderByLastModified()
    },
  },
  methods: {
    ...mapActions('user', []),
    ...mapActions('session', ['signInUser']),
    ...mapActions('video', ['getVideoProfileId']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapMutations('video', ['UPDATE_VIDEO']),
    formatDuration(seconds) {
      if (!seconds) return '00:00:00'

      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const remainingSeconds = seconds % 60

      const pad = (num) => String(num).padStart(2, '0')

      return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`
    },
    handleDeletePlaylist(playlist) {
      this.$root.$emit('removePlaylistModal', playlist)
    },
    handleRenamePlaylist(playlist) {
      this.$root.$emit('editPlaylistModal', playlist)
    },
    handleCreatePlaylist() {
      this.$root.$emit('editPlaylistModal', null, true)
    },
    openConvertingLink() {
      window.open(
        'https://help.pandavideo.com/pt-br/article/video-demorando-demais-para-converter-1uvumg4/',
        '_blank'
      )
    },
    openBlockedLink() {
      window.open(
        'https://help.pandavideo.com/pt-br/article/como-lidar-com-plagio-na-panda-video-scn24v/',
        '_blank'
      )
    },
    handleWidth() {
      let windowWidth = window.innerWidth

      if (windowWidth < 900) {
        this.columns[0].visible = false
      } else {
        this.columns[0].visible = true
      }

      if (windowWidth < 860) {
        this.columns[1].visible = false
        this.columns[2].visible = false
      } else {
        this.columns[1].visible = true
        this.columns[2].visible = true
      }
    },
    openFilterMenu(event) {
      const windowHeight = window.innerHeight
      const clickY = event.clientY
      this.availableSpaceBelow = windowHeight - clickY - 60

      this.menuX = event.clientX - 100
      this.menuY = clickY + 30

      this.menuVisible = true
    },
    syncListScrollWithHeaderScroll() {
      const _this = this
      if (!this.$refs.dataTableContent?.$el) {
        setTimeout(() => {
          _this.syncListScrollWithHeaderScroll()
        }, 100)
        return
      }
      this.$refs.dataTableContent.$el.onscroll = () => {
        _this.$refs.dataTableHeader.$el.scrollLeft =
          this.$refs.dataTableContent.$el.scrollLeft
      }
    },
    highlightRow(e, option = 'in') {
      const el = (e.target ?? e).closest('.item-line')
      const items = [...document.querySelectorAll('.item-line.rowIsDropOver')]

      for (const item of items) {
        if (item !== el) item.classList.remove('rowIsDropOver')
      }

      el.classList[option === 'in' ? 'add' : 'remove']('rowIsDropOver')
    },
    paramsToObject(entries) {
      const result = {}
      for (const [key, value] of entries) {
        result[key] = value
      }
      return result
    },
    verifyPermissions(permissions) {
      return (
        permissions.includes('create_video') ||
        permissions.includes('create-video')
      )
    },
    resizeTimeout() {
      clearTimeout(this.resizeWindowTimeout)
      this.resizeWindowTimeout = setTimeout(() => {
        this.setTableHeight()
      }, 300)
    },
    setTableHeight() {
      // prevent error using $refs (HTML not loaded)
      const getEl = (target) => document.querySelector(target)

      const actions = getEl('.data-table__actions')
      const header = getEl('.data-table__header')
      const content = getEl('.page-view__content')
      const line = getEl('.item-line')

      const aHeight = actions?.clientHeight || 65
      const hHeight = header?.clientHeight || 45
      const cHeight = content?.clientHeight || 600
      const lHeight = line?.clientHeight || 48

      const cPaddingTop = window
        .getComputedStyle(content, null)
        .getPropertyValue('padding-top')

      const differ = aHeight + hHeight - parseInt(cPaddingTop, 10)

      this.tableHeight = Math.abs(
        cHeight - differ - ((cHeight - differ) % lHeight)
      )
    },
    async pageRequests() {
      if (!window.db) {
        this.$root.$emit('initDexie')
      }
      this.isFetching = true
      this.fetchPlaylists()
    },
    async fetchPlaylists() {
      try {
        const playlists = await playlistApi.getPlaylists()
        this.playlists = playlists.data
      } catch (error) {
        console.error('Error fetching playlists:', error)
      } finally {
        this.isFetching = false
      }
    },
    removeDotIfItExists(value) {
      let dotIndex = value.indexOf('.')
      if (dotIndex === -1) return value
      return value.slice(0, dotIndex) + value.slice(dotIndex + 2, value.length)
    },
    orderByLastModified() {
      if (this.lastModifiedOrder === 'asc') {
        this.loadedFolders.sort(
          (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
        )
        this.loadedVideos.sort(
          (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
        )
      }
      if (this.lastModifiedOrder === 'desc') {
        this.loadedFolders.sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
        )
        this.loadedVideos.sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
        )
      }
    },
    handleOrderByLastModified() {
      if (!this.lastModifiedOrder || this.lastModifiedOrder === 'desc')
        return (this.lastModifiedOrder = 'asc')
      if (this.lastModifiedOrder === 'asc')
        return (this.lastModifiedOrder = 'desc')
    },
    handleClickRow(item) {
      this.handleDoubleClickRow(item)
    },
    handleAccessPlaylist(playlist) {
      this.$router.push({ name: 'PlaylistPage', params: { id: playlist.id } })
    },
    handleSettedOrder() {
      if (this.settedOrder == 'orderBySize') {
        this.orderBySize()
      }
      if (this.settedOrder == 'orderByLang') {
        this.orderByLang()
      }
      if (this.settedOrder == 'orderByTime') {
        this.orderByTime()
      }
      if (this.settedOrder == 'orderByLastModified') {
        this.orderByLastModified()
      }
      if (this.settedOrder == 'orderByName' || this.settedOrder == '') {
        this.orderByName()
      }
    },
    formatErr(err) {
      this.error.getFilesError = true
      const formattedErr = JSON.parse(JSON.stringify(err))
      let errFormattedText =
        err.msg ??
        err.response?.data?.errMsg ??
        err.response?.data?.message ??
        formattedErr?.message ??
        err ??
        'Error'
      if (this.error.tooltipErrMsg.length) {
        this.error.tooltipErrMsg =
          this.error.tooltipErrMsg + ' | ' + errFormattedText
      } else {
        this.error.tooltipErrMsg = errFormattedText
      }
      this.error.unknownError = true
      this.error.shownErrMsg = i18n.t('message.errors.unexpectedError')
      this.error.fetch = true
    },
    handleShowLink(item) {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.copiedToClipboard'),
        type: 'success',
      })
      navigator.clipboard.writeText(`${item}`)
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    openKnowMoreConverting() {
      window.open(PANDA_HELP_CONVERTING, 'blank')
    },
    handleControlClick(event, item) {
      if (item.title && item.status !== 'DRAFT') {
        if (event.ctrlKey === true) {
          // let routeData = this.$router.resolve({
          //   name: 'VideoPage',
          //   params: { id: item.id },
          // })
          // window.open(routeData.href, '_blank')
        }
      }
    },
    handleStatusPage() {
      return window.open(PANDA_STATUS_PAGE, '_blank')
    },
    updateColumnNames() {
      const updatedNames = [
        'Playlists',
        'Acesso',
        'Videos',
        'Duração',
        'Modificação',
      ]

      this.columns = this.columns.map((column, index) => ({
        ...column,
        name: updatedNames[index],
      }))
    },
    handleInput(event) {
      if (!this.bypassClickCloseMenu) {
        this.showMenu = event
      }
    },
    handleImageError(event) {
      event.target.src = require('@/assets/playlistPage/placeholder-pandaplaylist.svg')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/data-tableV2';

.v-icon.mdi-checkbox-blank-outline {
  color: #d0d1d9 !important;
}

.text-truncate {
  max-width: 350px;
  display: inline-block;
  text-align: left;
}

@media (max-width: 1610px) {
  .text-truncate {
    max-width: 270px;
  }
}

.v-menu__content {
  border-radius: var(--spacing-01, 2px);
  background: var(--neutral-100-white, #fff);
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
}

.v-list-item__content {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.v-list-item__title {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.caption {
  /* label/xs */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 12px */
}

// .tooltip-container {
//   position: relative;
// }
// .tooltip-position-bot {
//   bottom: 100%;
//   margin-bottom: -10px;
// }
// .tooltip-position-top {
//   top: 100%;
//   margin-top: -10px;
// }

.emptyStateTitle {
  font-size: 20px;
  font-weight: 400;
}

.data-table__header-fixed {
  height: 45px;
  position: fixed;
  z-index: 2;
  border-radius: 0px;
  top: 0;
  left: 270px;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15) !important;
}

.emptyStateDesc {
  font-size: 14px;
  font-weight: 400;
}

.btnStyle {
  padding: 16px;
  border-radius: 8px;

  span {
    text-transform: none;
    letter-spacing: 0px;
    font-size: 14px;
    font-weight: 500;
    line-height: 150%; /* 21px */
  }
}

.empty__container {
  height: 65vh;
  display: flex;
  align-items: center;
}

.v-menu__content[data-v-56fb59d6] {
  border-radius: 8px;
}

// converting loading

.nalps {
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  border: 2px solid varFigma(neutral-80-lighter);
  border-radius: 50%;
  border-top: 2px solid varFigma(brand-60-base);
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.blockedWarning {
  color: varFigma(feedback-danger-dark);
  display: flex;
  height: 18px;
  padding: 0px var(--spacing-02, 4px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-02, 4px);
  border-radius: var(--spacing-03, 8px);
  background: varFigma(feedback-danger-light);
}

// .tooltip-content {
//   position: absolute;
//   z-index: 9999 !important;
//   margin-left: -95px;
//   min-width: 200px;
//   padding: 5px;
//   background-color: rgba(97, 97, 97, 0.7);
//   color: #ffffff;
//   text-align: center;
//   border-radius: 6px;
//   white-space: normal;
//   word-wrap: break-word;
//   word-break: keep-all;
// }

.dupTooltip {
  width: 200px !important;
}

::v-deep body.scrollbar-light-mode ::-webkit-scrollbar-thumb {
  background-color: #d0d1d9 !important;
}

::v-deep body.scrollbar-dark-mode ::-webkit-scrollbar-thumb {
  background-color: #52577a !important;
}

::v-deep .virtual-scroller[data-v-7fd91582]:not(.page-mode) {
  padding-bottom: $spacing-11;
}

.selectedItensText {
  font-size: 12px;
  font-weight: 500;
}

.lang-flag {
  border-radius: 4px;
  margin: -16px 0 0 -24px !important;
  transform: scale(0.44) translateX(60%) translateY(38%) !important;
  -ms-transform: scale(0.44) translateX(60%) translateY(38%) !important;
  -webkit-transform: scale(0.44) translateX(60%) translateY(38%) !important;
  -moz-transform: scale(0.44) translateX(60%) translateY(38%) !important;
}

.pageInfo {
  color: var(--neutral-40-light, #636578);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
}

.flagContainer {
  padding: 2px 8px;
  border-radius: var(--spacing-03, 8px);
  border: 1px solid varFigma(neutral-95-lightest);
  background: varFigma(neutral-100-white);
}

.flagContainer:hover {
  border: 1px solid var(--neutral-95-lightest, #a0acff);
  cursor: pointer;
}

.columnIcon {
  color: varFigma(neutral-40-light) !important;
}

.dotsRow {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dotsActive {
  border-radius: var(--spacing-02, 4px);
  background: var(--neutral-90, #e3e4e8);
}

.fixed-header {
  width: 100% !important;
  position: absolute !important;
  top: 125px !important;
  left: 0 !important;
  border-bottom: 1px solid var(--neutral-95-lightest, #edeef1) !important;
  background: var(--neutral-100-white, #fff) !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 20px 0px !important;
}

.floatMenu {
  background: red;
  position: absolute;
  bottom: 200px;
  left: 50%; /* Centraliza o elemento horizontalmente */
  transform: translateX(-50%); /* Ajusta o centro do elemento */
  z-index: 999;
}

.page-videos {
  &::v-deep {
    .page-view__content {
      padding-bottom: 0;
    }

    .item-line {
      border-bottom: 1px solid varFigma(neutral-95-lightest);

      &.rowIsDropOver {
        .rowSlot > .row:not(.rowIsDragged) {
          background-color: var(--v-brand-lighten2);
        }
      }

      .rowSlot:has(.tooltip-container) {
        overflow: visible !important;
      }

      .rowIsSelected {
        background-color: #ebeeff !important;
      }

      .rowIsDragged {
        opacity: 0.5;
      }

      .hideGhostImage {
        display: none;
      }
    }

    .virtualTable {
      .item-line {
        &.rowIsDropOver {
          .rowSlot > .row:not(.rowIsDragged) {
            background-color: var(--v-neutral-base);
          }
        }

        .rowIsSelected {
          background-color: var(--v-neutral-darken1) !important;
          &:hover {
            background-color: var(--v-neutral-darken1) !important;
          }
        }
      }
    }
  }
}

div.item-line:hover .hoveredClass {
  display: block;
}

div.item-line .hoveredClass {
  display: none;
}

.router-link {
  cursor: pointer;
}

.buttons {
  margin-bottom: $spacing-plus-1;

  display: grid;
  overflow-x: auto;

  grid-template-columns: repeat(5, auto);
  column-gap: $spacing-minus-2;
  row-gap: $spacing-minus-2;

  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    margin-bottom: initial;
  }
}

.itemDesc {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
}

// .v-tooltip__content.menuable__content__active {
//   opacity: 0.9;
//   width: 375px;
// }

.storageContainer {
  width: 200px !important;
}

.mousearea {
  position: relative;
  user-select: none;

  &__effect {
    position: absolute;
    z-index: 10;

    background: #3e50f729;
    border: 1px dotted var(--v-brand-base);

    pointer-events: none;
  }

  &__dragging {
    position: absolute;
    z-index: 10;

    display: none;
    width: 282px;
    padding: $spacing-base;
    background-color: var(--v-neutral-lighten4);

    border-radius: var(--spacing-02, 4px);
    border: 1px solid varFigma(neutral-90);
    box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.3);

    color: var(--v-neutral-lighten1);
    pointer-events: none;

    &--name {
      display: block;
      overflow: hidden;

      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &--counter {
      $size: $spacing-plus-1;

      position: absolute;
      top: -7.5px;
      right: -7.5px;
      z-index: 1;

      display: flex;
      padding: 0 8px;
      height: 20px;
      border-radius: 16px;
      background-color: varFigma(brand-90);

      align-items: center;
      justify-content: center;

      font-size: 80%;
      color: varFigma(brand-20-darkest);
      font-weight: 500;
    }

    &.cascate {
      box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.3), 4px 4px 0px 0px #fff,
        3px 3px 5px 0px rgba(0, 0, 0, 0.3);
    }

    &.shrink {
      display: block;
      transform-origin: center;
      animation: shrink 0.25s cubic-bezier(0, 0, 0.15, 1);
    }

    &.dark-theme {
      color: #585d83;
    }

    @keyframes shrink {
      from {
        width: 1000px;
        background-color: var(--v-brand-lighten2);
        opacity: 0.75;
      }
      to {
        width: 282px;
        background-color: var(--v-neutral-lighten4);
        border-radius: var(--spacing-02, 4px);
        border: 1px solid varFigma(neutral-90);
        box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.3);
        opacity: 1;
      }
    }
  }
}

.fixed-menu {
  max-height: 300px !important;
  overflow-y: auto !important;
}

.menuIcon {
  color: varFigma(neutral-20-light) !important;
}

.menu-list {
  max-height: inherit !important;
}

.playlist-thumbnail {
  border-radius: var(--spacing-02, 4px);
  background: var(--neutral-100-white, #fff);
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
}

::v-deep.playlist-example {
  .v-icon {
    color: varFigma(brand-60-base);
  }
  & a:hover {
    text-decoration: none !important;
  }
}
</style>

<style lang="scss">
.uploadInput {
  display: none;
}

.selectedRow {
  background: var(--v-progressBar-lighten-1);
}

.noIbar {
  cursor: default;
}

.truncate {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.playIconMargin {
  margin-left: 7px;
  margin-right: 5px;
}

.svgArrowUp {
  position: relative;
  bottom: 300px;
  right: 40px;
}

.selectTemplate .v-list {
  padding: 0px;
}

.clickableText {
  cursor: pointer;
}

.t-header {
  display: none;
}

.t-header span {
  font-weight: bold;
}

div.item-line:hover .hoveredClass {
  display: block;
}

div.item-line .hoveredClass {
  display: none;
}

.displayBlock {
  display: block;
}

.displayNone {
  display: none;
}

.danger-remove {
  color: #f44336;
}

@keyframes removesMenu {
  from {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  }
  to {
    clip-path: polygon(50% 0, 50% 0, 50% 100%, 50% 100%);
  }
}

@keyframes appearsMenu {
  from {
    clip-path: polygon(50% 0, 50% 0, 50% 100%, 50% 100%);
  }
  to {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  }
}

.pointerTable {
  cursor: pointer;
}

.text-underlined {
  position: relative;
}

.text-underlined:after {
  content: '';
  position: absolute;
  width: 100%;
  bottom: 1px;
  border-width: 0px 0px 1px;
  border-style: solid;
  left: 3px;
}

.deletedText {
  text-decoration: line-through solid #6f6f6f 0.2px;
}

.video-row {
  flex-wrap: nowrap !important;
}

@media screen and (max-width: 1114px) {
  .responsive-text {
    white-space: nowrap;
  }
}

@media screen and (max-width: 769px) {
  .responsive-text {
    white-space: normal;
  }
}
</style>
